/**
 * Status do veículo.
 * Usado no PATCH /vehicles/{id}/status
 */
export enum VehicleStatus {
	Disponivel = 1,
	EmManutencao = 2,
	Inativo = 3,
}

export const VEHICLE_STATUS_OPTIONS: Array<{
	value: VehicleStatus;
	label: string;
	color: string;
}> = [
	{
		value: VehicleStatus.Disponivel,
		label: "Veículo disponível",
		color: "bg-utility-green-500",
	},
	{
		value: VehicleStatus.EmManutencao,
		label: "Em manutenção",
		color: "bg-utility-orange-500",
	},
	{
		value: VehicleStatus.Inativo,
		label: "Inativo",
		color: "bg-utility-gray-500",
	},
];

export function getVehicleStatusOption(status: number) {
	return (
		VEHICLE_STATUS_OPTIONS.find((o) => o.value === status) ??
		VEHICLE_STATUS_OPTIONS[0]
	);
}
